import { Injectable } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { DataConfirmModal } from '../../../features/shared/confirm-modal/confirm-modal.component'

@Injectable({
  providedIn: 'root'
})
export class CustomModalService {
  constructor(private modalService: NgbModal) {}

  public showModal(component: any, data?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const modalRef = this.modalService.open(component, { centered: true })
      modalRef.componentInstance.data = data
      modalRef.result
        .then((res) => resolve(res))
        .catch((err) => {
          if (err === 0 || err === 1) {
            resolve('')
          }
          reject(err)
        })
    })
  }

  public showConfirmModal(component: any, data: DataConfirmModal): Promise<boolean> {
    return new Promise((resolve) => {
      const modalRef = this.modalService.open(component, { centered: true })
      modalRef.componentInstance.data = data
      modalRef.result.then(
        () => resolve(true),
        () => resolve(false)
      )
    })
  }
}
